import { Suspense, useEffect } from "react";
import { useLocation, useNavigate, useRoutes } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import moment from "moment-timezone";

import appRoutes from "./configs/routes";
import LoadingModal from "./components/Loadings";
import NotFoundPage from "./components/NotFound/NotFound";

moment.tz.setDefault("Asia/Jakarta");

function App() {
  const routes = useRoutes(appRoutes);
  const isRunningOnMobile = Capacitor.getPlatform() !== "web";

  const baseUrl = window.location.origin;
  const isAllowedDomain =
    baseUrl.startsWith("https://perigigi-dental.com") ||
    baseUrl.startsWith("http://localhost");

  if (!isAllowedDomain && !isRunningOnMobile) {
    return <NotFoundPage />;
  }

  return (
    <Suspense fallback={<LoadingModal open={true} />}>
      {routes}
      <RouteListener />
    </Suspense>
  );
}

function RouteListener() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (Capacitor.getPlatform() !== "web") {
      let removeListener;

      import("@capacitor/app").then(({ App: AppC }) => {
        const backButtonListener = AppC.addListener("backButton", () => {
          console.log("Back button pressed at:", location.pathname);

          if (location.pathname === "/" || location.pathname === "/auths") {
            AppC.exitApp();
          } else {
            navigate(-1);
          }
        });

        removeListener = async () => {
          const back = await backButtonListener;
          await back.remove();
        };
      });

      // Cleanup listener saat unmount
      return () => {
        if (removeListener) removeListener();
      };
    }
  }, [location.pathname, navigate]);

  return null;
}

export default App;
